import {
  BaseballEventStatusId,
  BaseballIncidentId,
} from '@collector/sportsapi-client-legacy'

import { InningConfig } from './types'

export const otherStatusIncidents: BaseballIncidentId[] = [
  BaseballIncidentId.FinishedAwardedWin,
  BaseballIncidentId.NotStarted,
  BaseballIncidentId.Interrupted,
  BaseballIncidentId.Postponed,
  BaseballIncidentId.Abandoned,
  BaseballIncidentId.Cancelled,
  BaseballIncidentId.ToFinish,
]

export const inningsConfig: InningConfig[] = [
  {
    inningStatus: BaseballEventStatusId.FirstInning,
    breakAfterInning: BaseballIncidentId.BreakAfterFirstInning,
    breakStatus: BaseballEventStatusId.BreakAfterFirstInning,
    nextInningStarted: BaseballIncidentId.SecondInningStarted,
    canFinishRegularTimeInOther: true,
  },
  {
    inningStatus: BaseballEventStatusId.SecondInning,
    breakAfterInning: BaseballIncidentId.BreakAfterSecondInning,
    breakStatus: BaseballEventStatusId.BreakAfterSecondInning,
    nextInningStarted: BaseballIncidentId.ThirdInningStarted,
    canFinishRegularTimeInOther: true,
  },
  {
    inningStatus: BaseballEventStatusId.ThirdInning,
    breakAfterInning: BaseballIncidentId.BreakAfterThirdInning,
    breakStatus: BaseballEventStatusId.BreakAfterThirdInning,
    nextInningStarted: BaseballIncidentId.FourthInningStarted,
    canFinishRegularTimeInOther: true,
  },
  {
    inningStatus: BaseballEventStatusId.FourthInning,
    breakAfterInning: BaseballIncidentId.BreakAfterFourthInning,
    breakStatus: BaseballEventStatusId.BreakAfterFourthInning,
    nextInningStarted: BaseballIncidentId.FifthInningStarted,
    canFinishRegularTimeInOther: true,
  },
  {
    inningStatus: BaseballEventStatusId.FifthInning,
    breakAfterInning: BaseballIncidentId.BreakAfterFifthInning,
    breakStatus: BaseballEventStatusId.BreakAfterFifthInning,
    nextInningStarted: BaseballIncidentId.SixthInningStarted,
    canFinishRegularTimeInOther: true,
  },
  {
    inningStatus: BaseballEventStatusId.SixthInning,
    breakAfterInning: BaseballIncidentId.BreakAfterSixthInning,
    breakStatus: BaseballEventStatusId.BreakAfterSixthInning,
    nextInningStarted: BaseballIncidentId.SeventhInningStarted,
    canFinishRegularTimeInOther: true,
  },
  {
    inningStatus: BaseballEventStatusId.SeventhInning,
    breakAfterInning: BaseballIncidentId.BreakAfterSeventhInning,
    breakStatus: BaseballEventStatusId.BreakAfterSeventhInning,
    nextInningStarted: BaseballIncidentId.EighthInningStarted,
    canFinishRegularTimeInOther: true,
  },
  {
    inningStatus: BaseballEventStatusId.EighthInning,
    breakAfterInning: BaseballIncidentId.BreakAfterEighthInning,
    breakStatus: BaseballEventStatusId.BreakAfterEighthInning,
    nextInningStarted: BaseballIncidentId.NinthInningStarted,
    canFinishRegularTimeInOther: true,
    canFinishAfterExtraInningInOther: true,
  },
  {
    inningStatus: BaseballEventStatusId.NinthInning,
    breakAfterInning: BaseballIncidentId.BreakAfterNinthInning,
    breakStatus: BaseballEventStatusId.BreakAfterNinthInning,
    nextInningStarted: BaseballIncidentId.TenthInningStarted,
    canFinishRegularTimeInNext: true,
    canFinishAfterExtraInningInOther: true,
  },
  {
    inningStatus: BaseballEventStatusId.TenthInning,
    breakAfterInning: BaseballIncidentId.BreakAfterTenthInning,
    breakStatus: BaseballEventStatusId.BreakAfterTenthInning,
    nextInningStarted: BaseballIncidentId.EleventhInningStarted,
    canFinishAfterExtraInning: true,
  },
  {
    inningStatus: BaseballEventStatusId.EleventhInning,
    breakAfterInning: BaseballIncidentId.BreakAfterEleventhInning,
    breakStatus: BaseballEventStatusId.BreakAfterEleventhInning,
    nextInningStarted: BaseballIncidentId.TwelfthInningStarted,
    canFinishAfterExtraInning: true,
  },
  {
    inningStatus: BaseballEventStatusId.TwelfthInning,
    breakAfterInning: BaseballIncidentId.BreakAfterTwelfthInning,
    breakStatus: BaseballEventStatusId.BreakAfterTwelfthInning,
    nextInningStarted: BaseballIncidentId.ThirteenthInningStarted,
    canFinishAfterExtraInning: true,
  },
  {
    inningStatus: BaseballEventStatusId.ThirteenthInning,
    breakAfterInning: BaseballIncidentId.BreakAfterThirteenthInning,
    breakStatus: BaseballEventStatusId.BreakAfterThirteenthInning,
    nextInningStarted: BaseballIncidentId.FourteenthInningStarted,
    canFinishAfterExtraInning: true,
  },
  {
    inningStatus: BaseballEventStatusId.FourteenthInning,
    breakAfterInning: BaseballIncidentId.BreakAfterFourteenthInning,
    breakStatus: BaseballEventStatusId.BreakAfterFourteenthInning,
    nextInningStarted: BaseballIncidentId.FifteenthInningStarted,
    canFinishAfterExtraInning: true,
  },
  {
    inningStatus: BaseballEventStatusId.FifteenthInning,
    breakAfterInning: BaseballIncidentId.BreakAfterFifteenthInning,
    breakStatus: BaseballEventStatusId.BreakAfterFifteenthInning,
    nextInningStarted: BaseballIncidentId.SixteenthInningStarted,
    canFinishAfterExtraInning: true,
  },
  {
    inningStatus: BaseballEventStatusId.SixteenthInning,
    breakAfterInning: BaseballIncidentId.BreakAfterSixteenthInning,
    breakStatus: BaseballEventStatusId.BreakAfterSixteenthInning,
    nextInningStarted: BaseballIncidentId.SeventeenthInningStarted,
    canFinishAfterExtraInning: true,
  },
  {
    inningStatus: BaseballEventStatusId.SeventeenthInning,
    breakAfterInning: BaseballIncidentId.BreakAfterSeventeenthInning,
    breakStatus: BaseballEventStatusId.BreakAfterSeventeenthInning,
    nextInningStarted: BaseballIncidentId.EighteenthInningStarted,
    canFinishAfterExtraInning: true,
  },
  {
    inningStatus: BaseballEventStatusId.EighteenthInning,
    breakAfterInning: BaseballIncidentId.BreakAfterEighteenthInning,
    breakStatus: BaseballEventStatusId.BreakAfterEighteenthInning,
    nextInningStarted: BaseballIncidentId.NineteenthInningStarted,
    canFinishAfterExtraInning: true,
  },
  {
    inningStatus: BaseballEventStatusId.NineteenthInning,
    breakAfterInning: BaseballIncidentId.BreakAfterNineteenthInning,
    breakStatus: BaseballEventStatusId.BreakAfterNineteenthInning,
    nextInningStarted: BaseballIncidentId.TwentiethInningStarted,
    canFinishAfterExtraInning: true,
  },
  {
    inningStatus: BaseballEventStatusId.TwentiethInning,
    breakAfterInning: BaseballIncidentId.BreakAfterTwentiethInning,
    breakStatus: BaseballEventStatusId.BreakAfterTwentiethInning,
    nextInningStarted: BaseballIncidentId.TwentyFirstInningStarted,
    canFinishAfterExtraInning: true,
  },
  {
    inningStatus: BaseballEventStatusId.TwentyFirstInning,
    breakAfterInning: BaseballIncidentId.BreakAfterTwentyFirstInning,
    breakStatus: BaseballEventStatusId.BreakAfterTwentyFirstInning,
    nextInningStarted: BaseballIncidentId.TwentySecondInningStarted,
    canFinishAfterExtraInning: true,
  },
  {
    inningStatus: BaseballEventStatusId.TwentySecondInning,
    breakAfterInning: BaseballIncidentId.BreakAfterTwentySecondInning,
    breakStatus: BaseballEventStatusId.BreakAfterTwentySecondInning,
    nextInningStarted: BaseballIncidentId.TwentyThirdInningStarted,
    canFinishAfterExtraInning: true,
  },
  {
    inningStatus: BaseballEventStatusId.TwentyThirdInning,
    breakAfterInning: null,
    breakStatus: null,
    nextInningStarted: null,
    canFinishAfterExtraInning: true,
  },
]
